import type { PrescriptionSeverity, PrescriptionStatus } from "@interfaces";
import {
  PrescriptionStatusChipSeverityMapper,
  PrescriptionStatusMapper,
} from "@interfaces";
import { styled, Chip } from "@mui/material";

const StyledChip = styled(Chip, {
  shouldForwardProp: (prop: string) => prop !== "severity",
})<{ severity: PrescriptionSeverity }>(({ theme, severity }) => ({
  fontWeight: 600,
  backgroundColor: theme.palette[severity].light,
  color: theme.palette[severity].main,
}));

type Props = {
  status: PrescriptionStatus;
};

export const PrescriptionStatusLabel = ({ status }: Props) => {
  return (
    <StyledChip
      size="small"
      label={PrescriptionStatusMapper[status]}
      severity={PrescriptionStatusChipSeverityMapper[status]}
    />
  );
};
